import { render, staticRenderFns } from "./ChannelSupplierCreditQuotaOrder.vue?vue&type=template&id=1cd14736&"
import script from "./ChannelSupplierCreditQuotaOrder.vue?vue&type=script&lang=ts&"
export * from "./ChannelSupplierCreditQuotaOrder.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelSupplierCreditQuotaOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChannelSupplierCreditQuotaOrder.vue"
export default component.exports